export class EditorButtonConfiguration {
  showEdit: boolean;
  showCancel: boolean;
  showSave: boolean;
  disabledEdit: boolean;
  disabledCancel: boolean;
  disabledSave: boolean;
  autosave: boolean;


  constructor() {
    this.showEdit = false;
    this.showCancel = false;
    this.showSave = false;
    this.disabledEdit = false;
    this.disabledCancel = false;
    this.disabledSave = false;
    this.autosave = false;
  }

  static create(showEdit: boolean, showCancel: boolean, showSave: boolean, disabledEdit: boolean, disabledCancel: boolean, disabledSave: boolean, autosave: boolean) {
    const editorButtonConfiguration = new EditorButtonConfiguration();
    editorButtonConfiguration.showEdit = showEdit;
    editorButtonConfiguration.showCancel = showCancel;
    editorButtonConfiguration.showSave = showSave;
    editorButtonConfiguration.disabledEdit = disabledEdit;
    editorButtonConfiguration.disabledCancel = disabledCancel;
    editorButtonConfiguration.disabledSave = disabledSave;
    editorButtonConfiguration.autosave = autosave;
    return editorButtonConfiguration;
  }

  static createEnabled(): EditorButtonConfiguration {
    const enabled = new EditorButtonConfiguration();
    enabled.showEdit = true;
    return enabled;
  }

  static createDisabled() {
    return new EditorButtonConfiguration();
  }

  enabledSave() {
    this.showEdit = false;
    this.disabledEdit = true;

    this.showSave = true;
    this.disabledSave = false;

    this.showCancel = true;
    this.disabledCancel = false;
  }

  enabledEdit() {
    this.showEdit = true;
    this.disabledEdit = false;

    this.showSave = false;
    this.disabledSave = true;

    this.showCancel = false;
    this.disabledCancel = true;
  }
}
